/**
 * Boundaries Service
 * 
 * This service handles API calls related to district boundary management
 */

import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000';

export default {
  /**
   * Get all district boundaries
   * @returns {Promise} Promise with the boundaries data
   */
  async getBoundaries() {
    return axios.get(`${API_URL}/api/boundaries`);
  },

  /**
   * Get all neighborhood boundaries
   * @returns {Promise} Promise with the neighborhoods data
   */
  async getNeighborhoods() {
    return axios.get(`${API_URL}/api/neighborhoods`);
  }
};